// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/pagecontainer/components/chatinterface/index.scss
// module id = 2392
// module chunks = 13